module.exports = __webpack_public_path__ + "static/media/Consolas-01.98cbd740.svg";